export enum CampaignsGroupOperatorEnum {
    EQUAL = '=',
    GREATER_THAN = '>',
    LESS_THAN = '<',
    NOT_EQUAL = '<>',
    BETWEEN = 'BETWEEN',
    IN = 'IN',
    LIKE = 'LIKE'
}
